// extracted by mini-css-extract-plugin
module.exports = {"background":"Mian_background__1N1Cx","particles":"Mian_particles__2anzI"};